import type { VerifyComplianceSearchResult } from "@/models/responses/verify-compliance/verify-compliance.response";
import { CheckCircleIcon, SearchIcon, Spinner, XCircleIcon } from "./icons";

type CompanySearchProps = {
  value: string;
  onChange: (value: string) => void;
  onFocus: () => void;
  suggestions: VerifyComplianceSearchResult[];
  isSearching: boolean;
  showSuggestions: boolean;
  onSelect: (company: VerifyComplianceSearchResult) => void;
};

const CompanySearch = ({
  value,
  onChange,
  onFocus,
  suggestions,
  isSearching,
  showSuggestions,
  onSelect,
}: CompanySearchProps) => {
  return (
    <div className="relative max-w-2xl mx-auto">
      <div className="relative">
        <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          placeholder="Enter company name, RC number, employer code or PCC number..."
          className="w-full pl-12 pr-12 py-3.5 sm:py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-base sm:text-lg"
        />
        {isSearching && (
          <Spinner className="absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-emerald-600" />
        )}
      </div>

      {showSuggestions && suggestions.length > 0 && (
        <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-10 mt-2 overflow-hidden text-left">
          {suggestions.map((company) => (
            <button
              key={company.employerCode}
              onClick={() => onSelect(company)}
              className="w-full px-4 py-3 text-left hover:bg-gray-50 border-b border-gray-100 last:border-b-0 flex items-center justify-between"
            >
              <div>
                <p className="font-medium text-gray-900">
                  {company.companyName}
                </p>
                <p className="text-sm text-gray-500">
                  {company.cacNumber}
                  {company.sector ? ` • ${company.sector}` : ""}
                </p>
              </div>
              {company.isCompliant ? (
                <CheckCircleIcon className="h-4 w-4 text-green-600 shrink-0" />
              ) : (
                <XCircleIcon className="h-4 w-4 text-red-600 shrink-0" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CompanySearch;
